import { createContext } from 'react';
import { User, Terminal } from './../types';

export type UserContextObject = {
    user: User | null,
    setUser: (user: User | null) => void
};

export const UserContext = createContext<UserContextObject>({
    user: null,
    setUser: (user) => { return }
});

export type TerminalContextObject = {
    terminal: Terminal | null,
    setTerminal: (terminal: Terminal | null) => void
};

export const TerminalContext = createContext<TerminalContextObject>({
    terminal: null,
    setTerminal: (terminal) => { return }
});

export enum MapType {
    NONE,
    GOOGLE_MAPS
}

export type MapContexObject = {
    map: null | google.maps.Map,
    type: MapType,
    ready: boolean
}

export const MapContext = createContext<MapContexObject>({
    map: null,
    type: MapType.NONE,
    ready: true
});

//export type AlertContextObject = {
//    setLoading: (boolean) => void,
//    setProgress: (BooleanOrNull) => void
//};

//export const LoadingContext = createContext<AlertContextObject>({
//    setLoading: (boolean) => { return },
//    setProgress: (BooleanOrNull) => { return }
//});
